import React, { useEffect } from 'react';
import { Card } from '../../components/card';
import Renderer from '../../components/renderer';
import { getOptionValuesFromAnswer, getAnswerFromSelected, getAnswerKeyfromQuestion, getScoreForAnswer, getMarks } from '../../utils'
import CorrectAnswer from '../../components/results/CorrectAnswer'
import Answer from '../../components/results/Answer'
import MatchTheFollowing from '../../components/quiz/MatchTheFollowing';
import { evaluateMTF } from '../../utils';

export default function PreviewAssessment({ student, course, result, selectedAssessment }) {

    const evaluate = (type, selectedAnswer, currentOpt, answerLabels) => {
        let correct = false,
            wrong = false;

        if (!selectedAnswer) {
            selectedAnswer = [];
        }

        if (type == 'FIB') {
            let _answerLabels = answerLabels.map(e => String(e).toLowerCase());
            selectedAnswer = (Array.isArray(selectedAnswer) ? selectedAnswer : []).join('').toLowerCase();

            correct = _answerLabels.includes(selectedAnswer);
            wrong = !_answerLabels.includes(selectedAnswer);

        } else {
            let selectedAnswerLabels = Object.values(selectedAnswer).map(e => (e && e.length) ? e[0]['label'] : undefined);

            if (type == 'MCQ') {
                selectedAnswerLabels = Object.values(selectedAnswer).map(e => e ? e['label'] : undefined);
            }

            if (!answerLabels || !Array.isArray(answerLabels)) {
                answerLabels = [answerLabels];
            }

            correct = selectedAnswerLabels.includes(currentOpt.label) && answerLabels.includes(currentOpt.label);
            wrong = selectedAnswerLabels.includes(currentOpt.label) && !answerLabels.includes(currentOpt.label);
        }

        return { correct, wrong }
    }

    return (
        <Card style={styles.container} className='result-container'>
            <div style={styles.innerContainer} className='result-inner-container'>
                <div style={styles.resultsOverview}>
                    <div style={styles.courseDetails}>
                        <p style={styles.resultsOverviewParagraph}>
                            Name : {' '} {student?.firstName} {' '} {student?.lastName}
                        </p>
                        <p style={styles.resultsOverviewParagraph}>
                            Assessment : {' '} {selectedAssessment?.assessmentName}
                        </p>
                    </div>
                    <div style={styles.courseDetails}>
                        <p style={styles.resultsOverviewParagraph}>
                            Course : {' '}
                            {course?.courseName}
                        </p>
                        <p style={styles.resultsOverviewParagraph}>
                            Marks secured:
                            <span style={styles.highlightedText}> {Number(selectedAssessment?.scored).toFixed(1)} </span>/{' '}
                            {selectedAssessment?.total}
                        </p>
                    </div>

                </div>
                {result.map(
                    (
                        resultObject,
                        index
                    ) => {
                        const { questionDetails = {}, answerDetails = {}, selectedAnswer, type } = resultObject;
                        const values = getOptionValuesFromAnswer(answerDetails);
                        const MTFLHS = answerDetails?.options?.MTFLHS;
                        const MTFRHS = answerDetails?.options?.MTFRHS;
                        const answerKey = getAnswerKeyfromQuestion(resultObject);
                        const answerLabels = answerDetails.options?.answerLabels || [];
                        let score = getScoreForAnswer(selectedAnswer, answerDetails);

                        return (
                            <div key={index} style={styles.questionContainer}>
                                <div style={{ width: '90%' }}>
                                    <div style={styles.questionInnerContainer}>
                                        <h6 style={styles.questionNumber}>{`${index + 1}. `}</h6>
                                        {/* <span style={styles.question}>{questionDetails.text}</span> */}
                                        <Renderer content={questionDetails.text} mediaStyle={{ height: '150px', width: '150px' }} style={{ width: '90%' }}
                                            contentUrl={questionDetails.contentURL}
                                            contentType={questionDetails.style}
                                            overrideHTML={questionDetails.overrideHTML}
                                            contentDisplayType={type}
                                            disabled={true}
                                            templateType={questionDetails.displayTemplate} />
                                    </div>
                                    <div>
                                        <div className='grid-container'>
                                            {values && !(MTFLHS?.length) && values.length ? [...values].sort((a, b) => {
                                                return Number.parseInt(a.label) - Number.parseInt(b.label);
                                            }).map((ans, index) => {
                                                let { correct, wrong } = evaluate(type, selectedAnswer, ans, answerLabels);
                                                return (
                                                    <Answer className='grid-item' key={ans.label} label={ans.label} data={ans} content={ans.value.text} wrong={wrong} correct={correct} />
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {[selectedAnswer].map((ans, i) => {
                                                        if (type == 'MTF') {
                                                            let left = answerDetails.options?.MTFLHS;
                                                            let right = answerDetails.options?.MTFRHS;
                                                            let evaluated = evaluateMTF(left, right, ans, getMarks(answerDetails));

                                                            score = evaluated.score;

                                                            return <MatchTheFollowing key={i + 1} disabled={true} mode={'result'} questionId={resultObject.questionId} selectedAnswer={evaluated.ans} left={evaluated.left} right={evaluated.right} evaluated={true} />
                                                        }

                                                        ans = getAnswerFromSelected(ans);
                                                        let { correct, wrong } = evaluate(type, ans, null, answerLabels);

                                                        return <Answer className='grid-item' key={i} data={ans} content={(Array.isArray(ans) ? ans : []).join('')} wrong={wrong} correct={correct} />
                                                    })}
                                                </React.Fragment>
                                            )}
                                        </div>
                                        {/* only show if the answer is wrong and not MTF */}
                                        {!score && type != 'MTF' && (
                                            <CorrectAnswer answerLabels={answerLabels} type={type} choices={values} />
                                        )}
                                    </div>
                                </div>
                                <span style={styles.score} className={'scores ' + (score ? 'color-success' : 'color-wrong')}>{`Score ${score}`}</span>
                            </div>
                        )
                    }
                )}
            </div>
        </Card>
    )
}

const styles = {
    container: {
        border: 'none'
    },
    innerContainer: {
        background: 'var(--color-white)',
        borderRadius: '4px',
        margin: '0 auto',
        padding: '0 0 40px',
    },
    questionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '40px',
    },
    questionInnerContainer: {
        width: '100%',
        display: 'flex'
    },
    questionNumber: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        margin: 0,
        marginRight: '18px',
        color: 'var(--color-black)',
    },
    question: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        lineHeight: 1.3,
        color: 'var(--color-black)',
        marginBottom: '20px',
    },
    renderer: {
        width: '90%',
        marginBottom: '40px',
        paddingLeft: '40px'
    },
    score: {
        fontWeight: 500,
        fontSize: '16px',
        marginTop: '4px',
    },
    retryContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '40px'
    },
    highlightedText: {
        color: 'green',
    },
    resultsOverview: {
        textAlign: 'center',
        marginBottom: '40px',
    },
    resultsOverviewParagraph: {
        marginTop: '10px',
        fontWeight: 500,
        fontSize: '18px',
    },
    courseDetails: {
        display: 'flex',
        justifyContent: 'space-between'
    }
}